// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "@PayPlans/views/Layers/Departments/Technicians";

const POSITION = "Body Shop Painter";

export default function Painters() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	return (
		<PageLayer title={"Body Shop Painter Pay Plans"} icon={Icon}>
			<Layer position={POSITION} defaultSections={["default"]} />
		</PageLayer>
	);
}
